import React from 'react';
import PropTypes from 'prop-types';

function Strikethrough({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M15 6H9.40088C9.01688 5.99981 8.63844 6.08604 8.29735 6.25143C7.95626 6.41682 7.66249 6.65655 7.4407 6.95048C7.21892 7.24441 7.0756 7.58396 7.0228 7.94059C6.96999 8.29723 7.00924 8.66054 7.13724 9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 12C14.7956 12 15.5587 12.3161 16.1213 12.8787C16.6839 13.4413 17 14.2044 17 15C17 15.7956 16.6839 16.5587 16.1213 17.1213C15.5587 17.6839 14.7956 18 14 18H8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 12H18" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

Strikethrough.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Strikethrough;
